import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableRouteSettings = Loadable({
  loader: () => import('./RouteSettingsContainer.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableRouteSettings
